import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { AnyCnameRecord } from "dns";
import { Observable } from "rxjs";
import { ApiGateway } from "../../../api-gateway";
import { Environment } from "app/decorators/environment.decorator";

@Injectable()
export class ProfileProvider implements Resolve<any> {
    @Environment("baseUrl") baseUrl!: string;

    constructor(
        public gw: ApiGateway,
        private httpClient: HttpClient,
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        throw new Error("Method not implemented.");
    }

    getByUserId(userId: number) {
        return new Promise<any>((resolve, reject) => {
            this.gw.get("profile/user/:userId", { userId: userId }).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
            });
        });
    }

    getProfileAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("profile/").subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }
    getProfileChatByUserId(userId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .get("profile/profile-chat/user/:userId", { userId: userId })
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    save(profile: any) {
        return new Promise<any>((resolve, reject) => {
            this.gw.post("profile/", profile).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
            });
        });
    }

    /**
     * Carrega uma pagina de mensagens da conversa.
     *
     * Sem "beforeId"/"beforeSended" devolve as mensagens mais recentes.
     * Informando a mensagem mais antiga ja carregada, devolve a pagina anterior
     * (mensagens mais antigas que ela).
     *
     * @param {number} userFromId
     * @param {number} userToId
     * @param {number} limit
     * @param {number} beforeId id da mensagem mais antiga ja carregada
     * @param {string} beforeSended data/hora (ISO) da mensagem mais antiga ja carregada
     * @returns {Promise<any>} resposta com MessagePage em res.body
     */
    getMessagesPage(
        userFromId: number,
        userToId: number,
        limit: number,
        beforeId?: number,
        beforeSended?: string
    ): Promise<any> {
        // O ApiGateway monta a query a partir de "search", opcao que o HttpClient
        // do Angular ignora. Por isso os parametros vao na propria URL.
        const query: string[] = [`limit=${encodeURIComponent(limit)}`];

        if (beforeId != null && beforeSended) {
            query.push(`beforeId=${encodeURIComponent(beforeId)}`);
            query.push(`beforeSended=${encodeURIComponent(beforeSended)}`);
        }

        return new Promise<any>((resolve, reject) => {
            this.gw
                .get(`profile/messages/:userFromId/:userToId?${query.join("&")}`, {
                    userFromId: userFromId,
                    userToId: userToId,
                })
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    /**
     * Busca mensagens pelo texto em todas as conversas do usuario logado.
     *
     * O perfil vem da sessao no servidor, entao so o termo e enviado. Os
     * parametros vao na URL porque o ApiGateway monta a query a partir de
     * "search", opcao que o HttpClient do Angular ignora.
     *
     * @param {string} term texto digitado na busca
     * @returns {Promise<any>} MessageSearchResult[] em res.body, do resultado mais
     *                       recente para o mais antigo
     */
    searchMessages(term: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.gw
                .get(`message/search?term=${encodeURIComponent(term)}`)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    getEartefactbyId(eartefactId: number) {
        return new Promise<any>((resolve, reject) => {
            this.gw
                .get("profile/signature/:eartefactId", {
                    eartefactId: eartefactId,
                })
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                });
        });
    }

    deleteSignature(profileId: number, eartefactId: number) {
        return new Promise<any>((resolve, reject) => {
            this.gw
                .delete("profile/:profileId/signature/:eartefactId", {
                    profileId: profileId,
                    eartefactId: eartefactId,
                })
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                });
        });
    }

    uploadSgnature(file: File, profileId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            const endpoint =
                this.baseUrl + `profile/upload/signature/${profileId}`;
            const formData: FormData = new FormData();
            formData.append("file", file, file.name);

            const authToken: string = localStorage.getItem("token") || "";
            let headers = new HttpHeaders();
            if (authToken) {
                headers = headers.append("X-Auth-Token", authToken);
            }

            this.httpClient
                .post(endpoint, formData, { headers: headers })
                .subscribe({
                    next: (res) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }


    findMessageNotReaded(profileToId:number){
         return new Promise<any>((resolve, reject) => {
            this.gw
                .get(`message/find-message-no-readed/${profileToId}`)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                });
        });
    }
}
